import { render, staticRenderFns } from "./ClubCardListItem.vue?vue&type=template&id=2a38094b&"
import script from "./ClubCardListItem.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ClubCardListItem.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a38094b')) {
      api.createRecord('2a38094b', component.options)
    } else {
      api.reload('2a38094b', component.options)
    }
    module.hot.accept("./ClubCardListItem.vue?vue&type=template&id=2a38094b&", function () {
      api.rerender('2a38094b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/components/ClubCardListItem.vue"
export default component.exports